const clearSessionStorage = () => sessionStorage.clear()

const getSessionStorage = key => JSON.parse(sessionStorage.getItem(key))

const removeItemSessionStorage = key => sessionStorage.removeItem(key)

const setSessionStorage = (key, value) => sessionStorage.setItem(key, JSON.stringify(value))

export { clearSessionStorage, getSessionStorage, removeItemSessionStorage, setSessionStorage }
